import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Grid, Box, TextField, IconButton, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import AddEligibility from "./addEligibility";
import EligibilityTable from "./eligibilityTable";
import eligibilityCriteriaActions from "../../redux/eligibilityCriteria/actions";
import { useDispatch } from "react-redux";
import masterActions from "../../redux/master/actions";

export default function Index() {
  const dispatch = useDispatch();
  const naviagte = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
    const { eligibilityCriteria } = useSelector(state => state.eligibilityCriteriaReducer)
    const { courseList } = useSelector((state) => state.masterReducer);
     const [searchTerm, setSearchTerm] = useState("");
     const [selectedCourse, setSelectedCourse] = useState("");




      useEffect(() => {
        dispatch({ type: eligibilityCriteriaActions.GET_ELIGIBILITY_CRITERIA })
        dispatch({ type: masterActions.GET_COURSE_LIST });
      }, []);

  const filteredCriteria = useMemo(() => {
    const lowerSearch = searchTerm.toLowerCase();
    return eligibilityCriteria.filter((criteria) => {
      console.log(criteria, "insidefiltercmoinsoled")
      const name = criteria.eligibilitycriterianame || "";
      const nameMatch = name.toLowerCase().includes(lowerSearch);
      const courseMatch = selectedCourse
        ? criteria.courseid === selectedCourse
        : true;

      return nameMatch && courseMatch;
    });
  }, [searchTerm, selectedCourse, eligibilityCriteria]);

       console.log(courseList,"courselist consoeld")


 

  return (
    <Grid
      p={page === "eligibilitycriteria" ? "none" : 3}
      sx={{
        minHeight: "50vh",
        backgroundColor:
          page === "eligibilitycriteria"  ? "none" : "#fff",
        borderRadius: "8px",
      }}
    >
      {page === "eligibilitycriteria" && (
        <Grid container>
          <Grid
            item
            md={12}
            sx={{ display: "flex", justifyContent: "space-between",py:1 }}
          >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search eligibility criteria"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ minWidth: 300 }}
          />
          <FormControl size="small" sx={{ width: 300 }}>
          <InputLabel id="course-select-label">Select Course</InputLabel>
          <Select
            labelId="course-select-label"
            id="course-select"
            value={selectedCourse}
            label="Select Course"
            onChange={(e) => setSelectedCourse(e.target.value)}
          >
            {courseList?.all?.map((course) => (
              <MenuItem key={course.courseid} value={course.courseid}>
                {course.coursename}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        </Box>
            
            <MauvelousPrimaryButton
              title={"Add Eligibility"}
              handleClick={() =>
                naviagte(
                  `/${Cookies.get(
                    "mhet_mst_project"
                  )}/eligibility-management?page=addeligibility`
                )
              }
            />
          </Grid>
          <Grid item md={12}>
            <EligibilityTable eligibilityCriteria={filteredCriteria} />
          </Grid>
        </Grid>
      )}
      {page === "addeligibility" && <AddEligibility />}
      {page === "updateeligibility" && <AddEligibility />}
    </Grid>
  );
}
